import {FormControl, FormField} from 'platform/components';
import {Box, Center} from 'platform/foundation';

import {FieldPathByValue} from 'react-hook-form';

import {pushGtmEvent} from 'shared/web';

import {DeliveryNoteDocumentPreviewFormDefinition} from '../types/DeliveryNoteDocumentPreviewFormDefinition';

interface PageItemCheckboxProps {
  index: number;
  isConfirmed: boolean;
  control: FormControl<DeliveryNoteDocumentPreviewFormDefinition>;
  name: FieldPathByValue<DeliveryNoteDocumentPreviewFormDefinition, boolean>;
}

export function PageItemCheckbox(props: PageItemCheckboxProps) {
  return (
    <Box paddingHorizontal={2}>
      <Center>
        <FormField
          isDisabled={!props.isConfirmed}
          control={props.control}
          type="checkbox"
          name={props.name}
          onChange={() => {
            pushGtmEvent({event: 'button_click', event_id: 'ai_tool_dn_toggle_item'});
          }}
        />
      </Center>
    </Box>
  );
}
